class DrawerCartInvoice extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector("#CartDrawer-invoice");
    this.closeBtn = this.querySelector(".invoice-modal__close");
    this.openButton = this.querySelector('.invoice-open');
    this.overlay = this.querySelector(".invoice-modal__overlay");
    this.saveBtn = this.querySelector(".invoice-modal__save");
    this.afmInput = this.querySelector("#CartDrawer-afm");
    this.companyInput = this.querySelector("#CartDrawer-company");
    this.invoiceSaved = false;
    

    this.openButton.addEventListener('click', () => {
      this.open();
    });

    this.afmInput.addEventListener("input", () => {
      const errorEl = this.querySelector('#afm-error');
      this.afmInput.value = this.afmInput.value.replace(/\D/g, '').slice(0, 9);
      if (this.afmInput.value.length === 9) {
        errorEl.textContent = "";
      }
    });

    this.checkbox.addEventListener("change", () => {
      const invoiceLabel = this.querySelector(".invoice-open");
    
      if (!this.checkbox.checked) {
        invoiceLabel.textContent = "Θέλω Τιμολόγιο";
        invoiceLabel.classList.remove("invoice-saved");
        this.invoiceSaved = false;
      }
    });
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='checkbox']), select, textarea, [tabindex]";
    const focusableElements = () =>
      Array.from(
        this.querySelector(".invoice-modal__body").querySelectorAll(
          focusableElementsSelector,
        ),
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  connectedCallback() {
    this.init();
  }

  onSave() {
    const errorEl = this.querySelector('#afm-error');
    const afm = this.afmInput.value.trim();
    const invoiceLabel = this.querySelector('.invoice-open');
    
    if (!/^\d{9}$/.test(afm)) {
      errorEl.textContent = "Το ΑΦΜ πρέπει να έχει 9 ψηφία";
      return;
    }
    errorEl.textContent = "";
    this.checkbox.checked = true;
    this.invoiceSaved = true;

    const body = JSON.stringify({
      attributes: {
        "ΤΙΜΟΛΟΓΙΟ": "TRUE",
        "ΑΦΜ": afm,
        "ΟΝΟΜΑ ΕΠΙΧΕΙΡΗΣΗΣ": this.companyInput.value,
      },
    });
  
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    invoiceLabel.textContent = "Επεξεργασία στοιχείων τιμολογίου";
    invoiceLabel.classList.add("invoice-saved");
    this.close(true);
  }

  open() {
    if (this.hasAttribute("open")) return;
    const { focusableElements } = this.getFocusableElements();
    this.setAttribute("open", true);
    setTabindex(focusableElements(), "0");
    this.afmInput.focus();
  }

  close(keepChecked) {
    if (!this.hasAttribute("open")) return;
    const { focusableElements } = this.getFocusableElements();
    this.removeAttribute("open");
    setTabindex(focusableElements(), "-1");
    if (!keepChecked && !this.invoiceSaved && this.checkbox) {
      this.checkbox.checked = false;
    }
  }

  cancel() {
    this.checkbox.checked = false;
    const body = JSON.stringify({
      attributes: {
        "ΤΙΜΟΛΟΓΙΟ": "",
        "ΑΦΜ": "",
        "ΟΝΟΜΑ ΕΠΙΧΕΙΡΗΣΗΣ": "",
      },
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    this.afmInput.value = "";
    this.companyInput.value = "";
    this.close();
  }

  init() {
    this.checkbox?.addEventListener("change", () => {
      if (this.checkbox.checked) {
        this.open();
      } else {
        this.cancel();
      }
    });

    this.closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    this.overlay?.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    this.saveBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.onSave();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.hasAttribute("open")) {
          this.close();
        }
      }

      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }
}

customElements.define("drawer-cart-invoice", DrawerCartInvoice);
